<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="info" label-width="80px">
      <el-form-item label="分类名称">
        <el-input
          size="small"
          v-model.trim="info.typeName"
          placeholder="请填写分类名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否跨年">
        <el-radio-group
          size="small"
          v-model="info.isNewYears"
          :disabled="addOrEdit == 1"
        >
          <el-radio :label="0">不跨年</el-radio>
          <el-radio :label="1">跨年</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始日期">
        <div class="data">
          <el-date-picker
            size="small"
            type="date"
            placeholder="选择日期"
            v-model="info.startDate"
            style="width: 100%;"
            format="MM-dd"
            value-format="MM-dd"
            :disabled="addOrEdit == 1"
          ></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="结束日期">
        <div class="data">
          <el-date-picker
            size="small"
            type="date"
            placeholder="选择日期"
            v-model="info.endDate"
            style="width: 100%;"
            format="MM-dd"
            value-format="MM-dd"
            :disabled="addOrEdit == 1"
          ></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-time-picker
          size="small"
          placeholder="选择时间"
          v-model="info.startTime"
          style="width: 100%;"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
          :disabled="addOrEdit == 1"
        ></el-time-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-time-picker
          size="small"
          placeholder="选择时间"
          v-model="info.endTime"
          style="width: 100%;"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
          :disabled="addOrEdit == 1"
        ></el-time-picker>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group size="small" v-model="info.status">
          <el-radio :label="0">启用</el-radio>
          <el-radio :label="1">未启用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          size="small"
          type="textarea"
          v-model.trim="info.remarks"
          placeholder="请填写备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RestBroadcastSettingsAddOrEdit",
  components: {},
  props: {
    operateResize: {
      type: Number,
      return: 0
    },
    addOrEdit: {
      type: Number,
      default: {
        return: 0
      }
    },
    scheduleTypeId: {
      type: Number,
      return: 0
    }
  },
  data() {
    return {
      title: "",
      dialogVisible: false,
      id: 0,
      schoolId: parseInt(this.$store.state.schoolId),
      info: {
        scheduleTypeId: "",
        schoolId: this.schoolId,
        typeName: "",
        isNewYears: 0,
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        status: 0,
        remarks: "",
        addTime: ""
      }
    };
  },
  created() {},
  mounted() {},
  watch: {
    operateResize: function(newVal, oldVal) {
      if (this.scheduleTypeId == 0) {
        this.id = 0;
        this.title = "添加作息表";
        this.dialogVisible = true;
      } else {
        this.id = this.scheduleTypeId;
        this.title = "修改作息表";
        this.dialogVisible = true;
        this.getInfo();
      }
    }
  },
  computed: {},
  methods: {
    clearData() {
      this.info = {
        scheduleTypeId: "",
        schoolId: this.schoolId,
        typeName: "",
        isNewYears: 0,
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        status: 0,
        remarks: "",
        addTime: ""
      };
    },
    handleClose() {
      this.clearData();
      this.dialogVisible = false;
    },
    submit() {
      if (this.info.typeName == "") {
        this.$message("请填写分类名称！");
        return;
      }
      if (this.info.startDate == "") {
        this.$message("请选择开始日期！");
        return;
      }
      if (this.info.endDate == "") {
        this.$message("请选择结束日期！");
        return;
      }
      if (this.info.startTime == "") {
        this.$message("请选择开始时间！");
        return;
      }
      if (this.info.endTime == "") {
        this.$message("请选择结束时间！");
        return;
      }
      let req = {
        schoolId: this.schoolId,
        typeName: this.info.typeName,
        isNewYears: this.info.isNewYears,
        startDate: this.info.startDate,
        endDate: this.info.endDate,
        startTime: this.info.startTime,
        endTime: this.info.endTime,
        status: this.info.status,
        remarks: this.info.remarks
      };
      if (this.id != 0) {
        req = Object.assign(req, {
          scheduleTypeId: this.id
        });
      }
      this.operate(req);
    },
    async operate(req) {
      const loading = this.$loading({
        lock: true,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res = await this.$Http.addOrEditBroadcastRest(req, true);
      // console.log(res)
      loading.close();
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功！"
        });
        this.handleClose();
        this.$emit("getList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getInfo() {
      let req = {
        scheduleTypeId: this.id
      };
      let res = await this.$Http.getBroadcastRestInfo(req);
      // console.log(res)
      if (res.code == 200) {
        this.info = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style scoped>
.date {
}
</style>
